import React from 'react';
import styled from 'styled-components';
import { BoxArrowUpRight as Link } from '@styled-icons/bootstrap/BoxArrowUpRight';
import { clickedIds } from 'constants/analytics';
import { useTranslation } from 'react-i18next';
import { Cart } from '@styled-icons/bootstrap';
const Container = styled.div `
  display: flex;
`;
const Detail = styled.div `
  display: flex;
  align-items: center;
  padding-right: 16px;
  font-weight: 300;
`;
const DetailText = styled.div `
  padding-left: 6px;
  white-space: nowrap;

  a {
    display: block;
    color: inherit;
    text-decoration: none;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;
const CompanyDetails = ({ website, webshopUrl, className, }) => {
    const { t } = useTranslation();
    return (React.createElement(Container, { className: className },
        React.createElement(Detail, null,
            React.createElement(Link, { size: 10 }),
            React.createElement(DetailText, null,
                React.createElement("a", { href: website, target: "_blank", rel: "noreferrer", "data-tracking-id": clickedIds.productSummary }, t('website')))),
        webshopUrl && (React.createElement(Detail, null,
            React.createElement(Cart, { size: 10 }),
            React.createElement(DetailText, null,
                React.createElement("a", { href: webshopUrl, target: "_blank", rel: "noreferrer", "data-tracking-id": clickedIds.webshop }, t('buy-online')))))));
};
export default CompanyDetails;
